import type { ReactElement } from 'react';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { connect, dispatchAction } from '@ardoq/rxbeach';
import { IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { Features, featureOperations } from '@ardoq/features';
import { t, type I18nLocale } from '@ardoq/i18n';
import { featureContext$ } from 'streams/featureContext$';
import {
  isPptxExportRunning,
  pptxExport$,
  pptxExportRequested,
} from './pptxExport$';

type PptxExportButtonProps = {
  i18nLocale: I18nLocale;
  isRunning: boolean;
  isEnabled: boolean;
};

const PptxExportButtonContent = ({
  i18nLocale,
  isRunning,
  isEnabled,
}: PptxExportButtonProps): ReactElement | null => {
  if (!isEnabled) {
    return null;
  }
  return (
    <IconButton
      iconName={IconName.DOWNLOAD}
      label={
        isRunning
          ? t(
              i18nLocale,
              'presentationAdmin:viewer.topBar.exportingPptx',
              'Exporting…'
            )
          : t(
              i18nLocale,
              'presentationAdmin:viewer.topBar.exportPptx',
              'Export PPTX'
            )
      }
      onClick={() => dispatchAction(pptxExportRequested({ i18nLocale }))}
      isDisabled={isRunning}
      dataTestId="presentation-export-pptx"
    />
  );
};

export const PptxExportButton = connect(
  PptxExportButtonContent,
  combineLatest([pptxExport$, featureContext$]).pipe(
    map(([state, featureContext]) => ({
      isRunning: isPptxExportRunning(state),
      isEnabled: featureOperations.hasFeature(
        featureContext,
        Features.PRESENTATIONS_PPTX_EXPORT
      ),
    }))
  )
);
